import { BudgetVsActualData } from '../models/budget-vs-actual-data.model';
import * as reducers from '../reducers/budget-vs-actual-config.reducers';
import { createFeatureSelector, createSelector } from "@ngrx/store";

export const budgetVsActualConfigSelector = createFeatureSelector<reducers.State>('budgetVsActualConfig');

const { selectEntities } = reducers.adapter.getSelectors(budgetVsActualConfigSelector);

export const selectEntityByWidgetId = (widgetConfigId: number) =>
  createSelector(selectEntities, entities => entities[widgetConfigId]);

export const isLoading = (widgetConfigId: number) =>
  createSelector(selectEntityByWidgetId(widgetConfigId), entity => entity ? entity.loading : false);

export const getData = (widgetConfigId: number) =>
  createSelector(selectEntityByWidgetId(widgetConfigId), (entity) => {
    if (!entity || entity.loading) return null;
    return entity.data;
  });

export const getDefaultPeriodSelection = (widgetConfigId: number) =>
  createSelector(getData(widgetConfigId), (data) => {
    return data?.DefaultPeriod;
  });

export const getDefaultViewSelection = (widgetConfigId: number) =>
  createSelector(getData(widgetConfigId), (data) => {
    return data?.DefaultView;
  });

  export const getNumberOfHierarchyLevels = (widgetConfigId: number) =>
  createSelector(getData(widgetConfigId), (data) => {
    if(!data?.BudgetVsActualHierarchyItems){
      return 1;
    }
    return data?.BudgetVsActualHierarchyItems?.length + 1;
  });

export const getHierarchies = (widgetConfigId: number) =>
createSelector(getData(widgetConfigId), (data) =>
  {
    const orderOfItems = ["ScheduleName", "Class", "Category"]
    return data?.BudgetVsActualHierarchyItems
      .map(m =>
      {
        switch(m.SelectedValue)
        {
          case "Schedule": return { field: "ScheduleName", nameFunc: (items: BudgetVsActualData[]) => `${items[0]?.ScheduleRef} - ${items[0]?.ScheduleName}`};
          case "Cost Class": return { field: "Class", nameFunc: (items: BudgetVsActualData[]) => items[0]?.Class == null ? "No Class identified" : items[0].Class};
          case "Cost Category": return { field: "Category", nameFunc: (items: BudgetVsActualData[]) => items[0]?.Category == null ? "No Category identified" : items[0].Category};
          default: return {field: "", nameFunc: (items: BudgetVsActualData[]) => ""};
        }
      }).sort((a,b) =>
      {
        return orderOfItems.indexOf(a.field) - orderOfItems.indexOf(b.field)
      });
  });

export const getIncludeCommitments = (widgetConfigId: number) =>
  createSelector(getData(widgetConfigId), (data) => {
    return data?.IncludeCommitments;
  });
